import { useState, useEffect } from 'react';
import {
    ShieldCheck,
    BadgeCheck,
    CircleDollarSign,
    Phone,
    MessageCircleMore,
} from "lucide-react";
import { doc, collection, getDoc } from "firebase/firestore";
import { firestore } from "../firebase-config";
import { id_firebase } from "../content-site";
import { retiraMascara } from "../utils/retiraMascara";


export default function HeroSection() {
    const [telefone, setTelefone] = useState("");
    const [nome, setNome] = useState("");
    const [numero, setNumero] = useState("");

    useEffect(() => {
        const revendaRef = doc(collection(firestore, "revenda"), id_firebase);
        getDoc(revendaRef).then((docSnap) => {
            if (docSnap.exists()) {
                setTelefone(retiraMascara(docSnap.data().petelefone2, "link"));
                setNome(docSnap.data().penome_fantasia, "link");
                setNumero(docSnap.data().petelefone2, "link");
            }
        });
    }, []);


    return (
        <section className="
    bg-[#1B4FBF]
    rounded-2xl
    p-6
    flex
    flex-col
    lg:flex-row
    items-center
    gap-6
    relative
    overflow-hidden
    mt-32
    mx-auto
">

            {/* Pontos decorativos */}
            <div
                className="absolute right-64 top-0 bottom-0 w-32 opacity-20"
                style={{
                    backgroundImage:
                        "radial-gradient(circle, rgba(255,255,255,0.4) 1px, transparent 1px)",
                    backgroundSize: "10px 10px",
                }}
            />

            {/* Logo */}
            <div className="
    bg-black
    rounded-xl
    p-4
    flex
    items-center
    justify-center
    w-full
    max-w-[280px]
    lg:w-64
    shrink-0
">
                <img
                    src="/logo.png"
                    alt="M&A Multimarcas "
                    className="w-full h-auto object-contain"
                />
            </div>

            {/* Informações */}
            <div className="flex-1 min-w-0">
                <h2 className="text-white font-black text-xl uppercase tracking-wide mb-1">
                    {nome}
                </h2>

                <p className="text-white/70 text-sm mb-3">
                    Qualidade, confiança e o melhor negócio você encontra aqui!
                </p>

                <div className="flex items-center gap-5 flex-wrap">

                    <div className="flex items-center gap-1.5 text-white/80 text-xs">
                        <ShieldCheck className="w-5 h-5 shrink-0" />
                        Veículos revisados
                    </div>

                    <div className="flex items-center gap-1.5 text-white/80 text-xs">
                        <BadgeCheck className="w-5 h-5 shrink-0" />
                        Procedência garantida
                    </div>

                    <div className="flex items-center gap-1.5 text-white/80 text-xs">
                        <CircleDollarSign className="w-5 h-5 shrink-0" />
                        As melhores condições
                    </div>

                </div>
            </div>

            {/* Divider */}
            <div className="w-px self-stretch bg-white/20 shrink-0 mx-2" />

            {/* Contato */}
            <div className="flex flex-col gap-2 shrink-0 min-w-[200px]">

                <span className="text-white/55 text-[10px] font-medium uppercase tracking-[0.14em] text-center">
                    Entre em contato
                </span>

                <a
                    href="tel:11945678901"
                    className="flex items-center justify-center gap-2 text-white font-bold text-lg hover:text-white/90 transition"
                >
                    <Phone className="w-5 h-5 text-[#25D366]" />
                    {numero}
                </a>

                <a
                    href={`https://api.whatsapp.com/send?phone=55${telefone}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-2 bg-white text-[#1B4FBF] font-bold text-sm uppercase tracking-wider px-5 py-2.5 rounded-xl hover:bg-white/90 transition"
                >
                    <MessageCircleMore className="w-4 h-4 text-[#25D366]" />
                    Falar no WhatsApp
                </a>

            </div>

        </section>
    );
}